export const Scrollbar = {
    OVERLAY: 'overlay',
    FIXED: 'fixed',
};
export const MOUSE_EVENTS_SUPPORTED = ['mouseup', 'touchend'];
export const KEY = {
    arrowLeft: 'ArrowLeft',
    arrowUp: 'ArrowUp',
    arrowRight: 'ArrowRight',
    arrowDown: 'ArrowDown',
    escape: 'Escape',
    tab: 'Tab',
    enter: 'Enter',
    space: ' ',
    home: 'Home',
    end: 'End',
};
export const ListType = {
    action: 'action',
    select: 'select',
};
export const NOT_HOVERED_INDEX = -1;
export const DIVIDER_OPTION_VALUE = '-';
//# sourceMappingURL=DropdownLayout.constants.js.map